import React from 'react';
import ReactDropzone from 'react-dropzone';
import { Icon } from 'semantic-ui-react';

export const Dropzone = ({ children, ...props }) => (
  <ReactDropzone {...props}>
    <div className="file--dropzone-outline" />
    <div className="file--dropzone-icon-wrapper">
      <Icon name="arrow down" size="large" />
    </div>
    {children}
  </ReactDropzone>
);



// WEBPACK FOOTER //
// ./src/components/forms/Dropzone.js